/**
 * useVariantCollectsAiSettings — whether this line's sky settings belong on the
 * editing page.
 *
 * `ai_editing` never becomes a configuration tab of its own: it has no module, so
 * the step's Proceed gate could never see it confirmed. Its settings ride inside
 * the editing page instead, for the products whose catalogue entry announces
 * them — which is a per-VARIANT fact, not a per-shell one.
 */

import type { CartItemId } from 'models/purchaseFlowRevamp'

import { useCartLineCatalogueEntry } from '../useCartLineCatalogueEntry'

export function useVariantCollectsAiSettings(cartItemId: CartItemId): boolean {
  return !!useCartLineCatalogueEntry(cartItemId).variant?.configurationFlows?.includes('ai_editing')
}
